<template>
  <div>
    <div class="dropdown">
      <div
        type="text"
        class="form-select pointer"
        data-bs-toggle="dropdown"
        data-bs-display="static"
        :class="{ 'border-0': noBorder }"
      >
        <span v-if="_selected">{{ _selected }}</span>
        <span class="text-muted" v-else>{{ placeholder }}</span>
      </div>
      <ul class="dropdown-menu w-100">
        <li v-for="t in candidates" :key="t">
          <a
            href="javascript:0"
            class="dropdown-item small"
            @click="_selected = t"
          >
            {{ t }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const eventName = "change";
const eventSource = "selected";

export default {
  name: "EpiSelect",
  props: [eventSource, "candidates", "placeholder", "noBorder"],
  model: {
    prop: eventSource,
    event: eventName,
  },
  computed: {
    _selected: {
      get() {
        return this[eventSource];
      },
      set(v) {
        this.$emit(eventName, v);
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
.dropdown-menu
  max-height 250px
  overflow-y auto
</style>
